var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _g3, _path12, _g4, _path13, _path14, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2804 46.0615L100.764 45.5653C103.27 44.7267 106 46.088 106.838 48.5941L107.352 50.1284C108.19 52.6344 106.829 55.3647 104.323 56.2032L102.84 56.6995L99.2804 46.0615Z",
    fill: "#C9D1DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.582 50.551C116.691 49.3304 115.318 48.8998 113.31 49.1476C113.256 49.1542 113.203 49.1608 113.151 49.1672C111.964 49.313 111.167 49.4109 109.995 49.8587C108.72 50.3457 106.953 51.2706 103.971 53.2117C103.117 53.7676 101.974 53.5258 101.418 52.6717C100.862 51.8176 101.104 50.6745 101.958 50.1186C105.011 48.1315 107.036 47.0383 108.678 46.4112C110.278 45.8002 111.462 45.6555 112.65 45.5104C112.719 45.5019 112.789 45.4935 112.858 45.4849C115.681 45.1367 117.817 45.8102 121.246 46.8908C121.481 46.9647 121.721 47.0406 121.969 47.1182C122.941 47.4231 123.482 48.4586 123.177 49.431C122.872 50.4034 121.837 50.9445 120.865 50.6396C120.769 50.6096 120.675 50.5801 120.582 50.551Z",
    fill: "#C9D1DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59582 77.5173C6.41301 77.8297 4.94514 77.5393 3.03981 76.5863C2.12837 76.1304 1.01993 76.4997 0.564046 77.4111C0.108161 78.3226 0.477462 79.431 1.3889 79.8869C3.9123 81.149 6.13495 81.5976 9.11877 81.1705C9.17397 81.1626 9.22831 81.1548 9.28185 81.1472C10.4472 80.9807 11.2307 80.8688 12.1686 80.5778C13.1016 80.2883 14.1793 79.8246 16.0571 79.0091C16.9919 78.6031 17.4206 77.5163 17.0146 76.5815C16.6087 75.6468 15.5219 75.2181 14.5871 75.624C12.634 76.4722 11.771 76.8372 11.0751 77.053C10.4273 77.254 9.92235 77.3274 8.59582 77.5173Z",
    fill: "#C9D1DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8316 72.695L81.6364 75.2747C77.7674 76.2537 73.8367 73.9105 72.8577 70.0416L68.2141 51.6902C67.2351 47.8212 69.5783 43.8904 73.4472 42.9115L83.6425 40.3317C92.0078 38.2149 100.472 43.3051 102.576 51.6181L103.105 53.7095C105.222 62.0748 100.131 70.5392 91.8184 72.6427L91.8316 72.695Z",
    fill: "url(#paint0_linear_2701_1409)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.1507 74.8797C83.1507 74.8797 85.6316 68.7855 82.2878 56.0578C79.807 46.7277 74.8453 42.5211 74.8453 42.5211L73.6049 42.8447C73.6049 42.8447 80.562 55.141 80.4542 58.6465C80.3463 62.152 82.6653 74.9876 82.6653 74.9876L83.2047 74.8258L83.1507 74.8797Z",
    fill: "#646A70"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7512 61.6124C65.785 49.9633 63.1963 39.7164 69.7759 38.9074C73.3893 38.4759 78.5127 46.7274 81.4789 58.3765C84.4451 70.0256 83.6901 79.4096 80.4542 81.0815C74.9532 83.8859 71.7174 73.2615 68.7512 61.6124Z",
    fill: "#DAE2EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.561 81.6208C81.5351 80.8682 81.5532 70.8013 78.6013 59.1357C75.6495 47.4702 70.8455 38.6234 67.8714 39.376C64.8972 40.1286 64.8792 50.1955 67.831 61.8611C70.7828 73.5267 75.5868 82.3734 78.561 81.6208Z",
    fill: "#DAE2EC"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5608 81.6184C81.535 80.8658 81.5531 70.7989 78.6012 59.1333C75.6494 47.4677 70.8454 38.621 67.8713 39.3735C64.8971 40.1261 64.879 50.193 67.8309 61.8586C70.7827 73.5242 75.5867 82.371 78.5608 81.6184Z",
    fill: "url(#paint1_linear_2701_1409)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1489 54.1144C72.6343 56.002 72.5264 57.6738 71.9332 57.8356C71.3399 57.9974 70.4231 56.5413 69.9377 54.6537C69.4523 52.7661 69.5602 51.0942 70.1534 50.9325C70.7467 50.7707 71.6635 52.2268 72.1489 54.1144Z",
    fill: "#4B5256"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6544 66.8422C76.1397 68.7298 76.0319 70.4016 75.4386 70.5634C74.8454 70.7252 73.9286 69.2691 73.4432 67.3815C72.9578 65.4939 73.0657 63.822 73.6589 63.6602C74.2522 63.4984 75.169 64.9546 75.6544 66.8422Z",
    fill: "#4B5256"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6353 81.7642L20.1126 82.1213C17.5398 82.7247 14.9469 81.1171 14.3435 78.5443L13.974 76.9691C13.3706 74.3963 14.9782 71.8035 17.551 71.2L19.0737 70.8429L21.6353 81.7642Z",
    fill: "#C9D1DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8234 66.0621C56.6818 77.7651 56.5739 87.7963 53.6077 88.4974C50.6415 89.1985 45.8955 80.3538 43.0372 68.6508C40.1789 56.9477 40.2867 46.9166 43.2529 46.2155C46.2191 45.5144 50.9651 54.3591 53.8234 66.0621Z",
    fill: "#DAE2EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.918 55.0517L40.1354 52.5609C44.0127 51.6157 47.9229 53.9932 48.8681 57.8705L53.3514 76.2618C54.2966 80.1391 51.9192 84.0493 48.0418 84.9945L37.8245 87.4852C29.441 89.5289 21.0214 84.365 18.9905 76.0339L18.4795 73.9381C16.4359 65.5546 21.5997 57.135 29.9308 55.1041L29.918 55.0517Z",
    fill: "url(#paint2_linear_2701_1409)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6149 52.9032C38.6149 52.9032 36.0801 58.9435 39.316 71.7252C41.7429 81.1092 46.6506 85.3158 46.6506 85.3158L47.891 84.9922C47.891 84.9922 41.0418 72.642 41.2036 69.1365C41.3653 65.631 39.1542 52.7415 39.1542 52.7415L38.6149 52.8493V52.9032Z",
    fill: "#646A70"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9606 66.2775C55.819 77.9805 58.3537 88.2274 51.7741 88.9824C48.1608 89.36 43.0912 81.0546 40.2329 69.4055C37.3746 57.7024 38.1835 48.3184 41.4194 46.7005C46.9204 43.95 50.1023 54.6284 52.9606 66.2775Z",
    fill: "#DAE2EC"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8234 66.0621C56.6818 77.7651 56.5739 87.7963 53.6077 88.4974C50.6415 89.1985 45.8955 80.3538 43.0372 68.6508C40.1789 56.9477 40.2867 46.9166 43.2529 46.2155C46.2191 45.5144 50.9651 54.3591 53.8234 66.0621Z",
    fill: "url(#paint3_linear_2701_1409)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1086 59.9145L47.028 62.9886C47.028 62.9886 46.9741 62.9886 46.9202 62.9886C45.5719 61.3707 45.1944 59.7527 45.7337 58.0269C45.7337 58.0269 45.7337 57.973 45.7876 57.973L57.9222 54.8989C59.3244 54.5753 60.7266 55.3843 61.0502 56.7865C61.3738 58.1887 60.5648 59.5909 59.1626 59.9145H59.1086Z",
    fill: "#EDEDED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3985 73.5037L50.264 76.5783C49.0236 75.0682 48.4303 73.4503 49.0236 71.5627L61.1581 68.4881C62.5603 68.1645 63.9625 68.9735 64.2861 70.3757C64.6097 71.7779 63.8007 73.1801 62.3985 73.5037Z",
    fill: "#EDEDED"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6444 32.3103L54.426 28.148C54.2983 27.7117 53.8446 27.4644 53.4127 27.5956C52.9808 27.7269 52.7342 28.1871 52.8619 28.6234L54.0802 32.7856C54.208 33.2219 54.6617 33.4693 55.0936 33.338C55.5255 33.2067 55.7721 32.7466 55.6444 32.3103Z",
    fill: "url(#paint4_linear_2701_1409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5077 34.9649L47.7017 31.6581C47.4076 31.3114 46.8925 31.27 46.5513 31.5656C46.2101 31.8612 46.172 32.3819 46.4662 32.7285L49.2721 36.0354C49.5662 36.382 50.0813 36.4234 50.4225 36.1278C50.7637 35.8322 50.8018 35.3116 50.5077 34.9649Z",
    fill: "url(#paint5_linear_2701_1409)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7828 32.5334L61.8088 28.3197C61.9163 27.8779 61.6471 27.4369 61.2074 27.3346C60.7677 27.2323 60.3241 27.5075 60.2165 27.9493L59.1905 32.163C59.083 32.6048 59.3522 33.0458 59.7919 33.1481C60.2316 33.2504 60.6752 32.9752 60.7828 32.5334Z",
    fill: "url(#paint6_linear_2701_1409)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2701_1409",
    x1: 82.1329,
    y1: 41.4335,
    x2: 92.5686,
    y2: 71.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2701_1409",
    x1: 64.9482,
    y1: 42.1266,
    x2: 84.3156,
    y2: 76.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#535353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2701_1409",
    x1: 29.0059,
    y1: 57.0865,
    x2: 37.5441,
    y2: 88.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392372,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9D1DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2701_1409",
    x1: 43.7106,
    y1: 48.0739,
    x2: 51.3002,
    y2: 86.0218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#929292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252525"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2701_1409",
    x1: 53.0018,
    y1: 27.4193,
    x2: 51.9482,
    y2: 32.8207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2701_1409",
    x1: 46.1042,
    y1: 31.5717,
    x2: 47.3387,
    y2: 36.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2701_1409",
    x1: 60.9397,
    y1: 26.9764,
    x2: 57.3266,
    y2: 31.1274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FA1B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F7083"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.9ad171db43950478de0da35dc683a1a6.svg";
export { ForwardRef as ReactComponent };